import { i18n } from "@euroland/libs";

const TickerName = ({ shareName, marketAbbreviation }) => {
  return (
    <span className="ticker-name">
      <span className="ticker-name__share-name">{shareName}</span>&nbsp;
      {marketAbbreviation ? (
        <span className="ticker-name__market-abbreviation">
          {i18n.translate("marketAbbreviationFormat", marketAbbreviation)}
        </span>
      ) : null}
    </span>
  );
};

export default TickerName;
